import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MakeDraftIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "MakeDraft",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.09 19.78c.12-.46.23-.93.23-1.39v-.12c0-.46-.46-.81-.81-.81h-.23c-.35.12-.58.46-.81.7-.35.58-.58 1.16-.81 1.86-.23.58-.7 1.98-1.05 2.09h-.12s-.12 0-.12-.12c-.35-.58.35-2.44.81-3.83l.12-.35c.7-2.09 1.05-3.37.7-4.18v-.12c-.12-.23-.35-.35-.58-.46-1.39-.46-2.9 1.05-4.65 4.41-.93 1.63-1.74 3.37-2.32 5.23 0 .46.35.81.81.81.35 0 .7-.23.81-.58l.12-.35c.58-1.51 1.28-3.02 1.98-4.41v-.12c.58-1.16 1.28-2.21 2.21-3.14-.12.7-.46 1.63-.7 2.21l-.12.35c-.7 2.09-1.28 3.83-.7 5.11.23.46.7.93 1.28 1.05.12.12.35.12.46.12.93 0 1.51-.7 1.98-1.51l.12.12c.7.7 2.21.81 4.3.35.46 0 .81-.46.81-.93s-.35-.81-.81-.81h-.35c-.93.23-1.86.35-2.79.12-.12.12.12-.93.23-1.28Zm8.02-9.53q-.12-.23-.23-.35l-7.55-7.55c-.12-.12-.23-.12-.23-.23h-.12c-.12 0-.23-.12-.35-.12H9.1C6.78 2 4.92 3.86 4.8 6.18v20.1C4.8 28.49 6.54 30 8.98 30h13.94c2.44 0 4.18-1.51 4.18-3.72V10.94c.12-.35.12-.46 0-.7ZM24.44 26.4c0 .81-.81.93-1.39.93H9.11c-.7 0-1.39-.12-1.39-.93V6.3c0-.81.58-1.39 1.39-1.39h7.9v5.11c0 1.28 1.05 2.32 2.32 2.32h5.11z"
    })
  }));
};